import { setYear } from './set-year';
/**
 * @hidden
 */
export var normalizeYear = function (value, year) { return (setYear(value, year(value.getFullYear()))); };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-date-math/dist/es/normalize-year.js
// module id = 147
// module chunks = 93